module.exports = __webpack_public_path__ + "img/bg.320661d9.webp";